<template>
  <div class="admin-page">
    <h1>Aura Gas Cover Calculator - Settings</h1>
    <div class="tabs">
      <div class="tab" @click="tab = 'plans'" :class="{ active: tab === 'plans'}">Plans</div>
      <div class="tab" @click="tab = 'new_plan'" :class="{ active: tab === 'new_plan'}">New Plan</div>
      <div class="tab" @click="tab = 'discounts'" :class="{ active: tab === 'discounts'}">Reference Codes</div>
      <div class="tab" @click="tab = 'new_discount'" :class="{ active: tab === 'new_discount'}">New Reference Code</div>
      <div class="tab" @click="tab = 'upcosts'" :class="{ active: tab === 'upcosts'}">Upcosts</div>
      <div class="tab" @click="tab = 'email'" :class="{ active: tab === 'email'}">Email Content</div>
      <div class="tab" @click="tab = 'logs'" :class="{ active: tab === 'logs'}">Order Log</div>
      <div class="tab" @click="tab = 'reset'" :class="{ active: tab === 'reset'}">Reset Plugin</div>
      <div class="tab disabled" :class="{ active: tab === 'edit_plan'}">Edit Plan</div>
      <div class="tab disabled" :class="{ active: tab === 'edit_discount'}">Edit Discount</div>
    </div>
    <div class="tab-content">
      <plans v-if="tab === 'plans'" :base="base" @edit="switchEditPlan"></plans>
      <plan-creator v-else-if="tab === 'new_plan'" @save="tab = 'plans'" :base="base"></plan-creator>
      <upcosts v-else-if="tab === 'upcosts'" @save="tab = 'plans'" :base="base"></upcosts>
      <discounts v-else-if="tab === 'discounts'" :base="base" @edit="switchEditDiscount"></discounts>
      <discount-creator v-else-if="tab === 'new_discount'" @save="tab = 'discounts'" :base="base"></discount-creator>
      <plan-editor v-else-if="tab === 'edit_plan'" @save="tab = 'plans'" :base="base" :insert="editPlan"></plan-editor>
      <discount-editor v-else-if="tab === 'edit_discount'" @save="tab = 'discounts'" :base="base" :insert="editDiscount"></discount-editor>
      <email-maker v-else-if="tab === 'email'" @save="tab = 'plans'" :base="base"></email-maker>
      <reset v-else-if="tab === 'reset'" @save="tab = 'plans'" :base="base"></reset>
      <order-log v-else-if="tab === 'logs'" :base="base"></order-log>
    </div>
  </div>
</template>

<script>
import Plans from './components/admin/Plans';
import PlanCreator from "./components/admin/PlanCreator";
import Discounts from "./components/admin/Discounts";
import DiscountCreator from "./components/admin/DiscountCreator";
import DiscountEditor from "./components/admin/DiscountEditor";
import Upcosts from "./components/admin/Upcosts";
import PlanEditor from "./components/admin/PlanEditor";
import EmailMaker from "./components/admin/EmailMaker";
import OrderLog from "./components/admin/OrderLog";
import Reset from "./components/admin/Reset";

export default {
  name: "Admin",
  components: {
    Plans,
    PlanCreator,
    PlanEditor,
    Discounts,
    DiscountCreator,
    DiscountEditor,
    Upcosts,
    EmailMaker,
    OrderLog,
    Reset
  },
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data(){
    return{
      tab: 'plans',
      editPlan: null,
      editDiscount: null,
    }
  },
  methods: {
    switchEditPlan(plan){
      this.editPlan = plan;
      this.tab = 'edit_plan';
    },
    switchEditDiscount(discount){
      this.editDiscount = discount;
      this.tab = 'edit_discount';
    },
  }
}
</script>

<style lang="scss" scoped>
.admin-page {
  width: 100%;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;

  h1 {
    font-weight: normal;
    font-size: 1.4rem;
    padding: 0.2rem 0;
  }

  .tab-content{
    padding: 0.5rem 0;
    border-top: 2px solid #CCCCCC;
    margin-top: -1px;
  }

  .tabs{
    display: flex;
    width: 100%;
    .tab{
      padding: 0.4rem 0.5rem;
      cursor: pointer;
      font-size: 1rem;
      margin-left: 1rem;
      color: #555555;
      border: 1px solid #CCCCCC;
      background-color: #E5E5E5;
      font-weight: normal;
      &.disabled{
        background-color: #949494;
        cursor: default;
      }
      &.active{
        border-bottom: 0;
        background-color: #F1F1F1;
        color: #000;
        padding-bottom: calc(0.4rem + 1px);
        margin-bottom: -1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Admin.vue